export default __webpack_public_path__ + "static/media/comments_open_icon.7bb4267a.svg";